// UI-only constants

export const INVESTMENT_TYPE = { REAL: 0, VIRTUAL: 1 };
export const INVESTMENT_TYPE_LABEL = { 0: 'Real', 1: 'Virtual' };

// Contract ActivityType enum:
// 0 None, 1 Invest (=Purchase), 2 MiningClaim, 3 LevelIncome (=Level Rewards),
// 4 Withdraw, 5 Blacklist, 6 MiningDone, 7 PoolIncome, 8 PoolEligibilityChanged
export const ACTIVITY_TYPE = {
  0: 'None',
  1: 'Purchase',
  2: 'Mining Claim',
  3: 'Level Reward',
  4: 'Withdraw',
  5: 'Blacklist',
  6: 'Machine Ended',
  7: 'Pool Reward',
  8: 'Pool Tier Changed',
};

export const ACTIVITY_ICON = {
  1: '💎',
  2: '⛏️',
  3: '🎁',
  4: '💰',
  5: '🚫',
  6: '⚠️',
  7: '🏆',
  8: '📈',
};

// Pool tier labels (contract encodes 0=none, 1=X1, 2=X2, 3=X3)
export const POOL_LABELS = { 0: 'None', 1: 'X1', 2: 'X2', 3: 'X3' };
export const POOL_NAMES  = { 0: 'Not Qualified', 1: 'X1 Pool', 2: 'X2 Pool', 3: 'X3 Pool' };

// XTerra Forge — machine names per tier
export const TIER_LABELS = [
  'XTerra Forge N1',
  'XTerra Forge N2',
  'XTerra Forge N3',
  'XTerra Forge X1',
  'XTerra Forge X2',
  'XTerra Forge X3',
  'XTerra Forge Pro',
  'XTerra Forge Ultra',
  'XTerra Forge Titan',
];

export const TIER_SHORT = ['N1', 'N2', 'N3', 'X1', 'X2', 'X3', 'Pro', 'Ultra', 'Titan'];

// Image paths — drop PNGs at /public/machines/*.png
export const MACHINE_IMAGES = [
  '/machines/forge-n1.png',
  '/machines/forge-n2.png',
  '/machines/forge-n3.png',
  '/machines/forge-x1.png',
  '/machines/forge-x2.png',
  '/machines/forge-x3.png',
  '/machines/forge-pro.png',
  '/machines/forge-ultra.png',
  '/machines/forge-titan.png',
];

// Marketing taglines
export const TIER_TAGLINES = [
  'Entry-level mining core. Low power, steady returns.',
  'Balanced performer. Enhanced daily throughput.',
  'Advanced N-series with improved hash stability.',
  'Xtreme-line launch. Boosted mining envelope.',
  'Second-gen Xtreme. Higher sustained yield.',
  'Peak Xtreme model. Elevated performance ceiling.',
  'Professional-tier machine. Enterprise-grade rewards.',
  'Ultra-class rig. Massive daily throughput.',
  'Titan-class flagship. Maximum mining capability.',
];

// Rank badges
export const TIER_TIER_LEVEL = [
  'NORMAL', 'NORMAL', 'NORMAL',
  'XTREME', 'XTREME', 'XTREME',
  'ELITE', 'ELITE', 'FLAGSHIP',
];
